import { ExpenseAccount } from "@finway-group/shared/lib/models"

export const expenseAccount: ExpenseAccount = {
    accountName: "My expense account",
    accountCode: "3707",
} as ExpenseAccount
